import { orderBy } from 'lodash-es';
import { contactFullName } from './ContactsDashboardRow.utils';
export const SORT_IDS = [
    'contactName',
    'email',
    'phone'
];
export const SEARCHABLE_KEYS = [
    'firstName',
    'lastName',
    'email',
    'phone',
    'associatedCustomers.*.customerName'
];
const sortValueByColIndex = {
    0: (contact)=>contactFullName(contact).toLowerCase(),
    1: (contact)=>contact.email.toLowerCase(),
    2: (contact)=>{
        var _contact_phone;
        return (_contact_phone = contact.phone) !== null && _contact_phone !== void 0 ? _contact_phone : '';
    }
};
export const sortContacts = (contacts, tableSort)=>{
    if (tableSort == null) return contacts;
    const sortValue = sortValueByColIndex[tableSort.colIndex];
    return sortValue == null ? contacts : orderBy(contacts, sortValue, tableSort.sort);
};
